// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 449 ? "c06d7c9d" : chunkId) + "." + {"449":"deea72e7fee2656e","604":"ff74efb264fdc992"}[chunkId] + ".js";
};